/// <reference path="../../_ext/Editors/EditorDialogBase.ts" />

namespace TabAurous.ECommerce {
    export var amount: number = 0;    
    
    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.maximizable(false)
    export class ECommSalesReceiptDialog extends _Ext.ItemEditorDialog<ECommSalesReceiptRow> {
        protected getFormKey() { return ECommSalesReceiptForm.formKey; }
        protected getLocalTextPrefix() { return ECommSalesReceiptRow.localTextPrefix; }

        protected get_ExtDialogOptions() {
            let opt = super.get_ExtDialogOptions();
            opt.AutoFitContentArea = false;
            return opt;
        }

        protected form = new ECommSalesReceiptForm(this.idPrefix);
        constructor() { 
            super();
             
            q.setTextRightAlign(this.form.Amount);
            q.setTextRightAlign(this.form.Total);
            q.setTextRightAlign(this.form.Balance);


            this.form.ModeId.changeSelect2(e => {
                var ledger = OMS.PaymentModeRow.getLookup().itemById[this.form.ModeId.value];
                this.form.LedgerId.value = ledger.LedgerId.toString();
                
                Serenity.EditorUtils.setReadOnly(this.form.LedgerId, true);
                if (ledger.Type == 280) { //For Gift Voucher
                    Serenity.EditorUtils.setReadOnly(this.form.Amount, false);
                    q.hideField(this.form.ChequeDate, true);
                    q.hideField(this.form.ChequeNo, true);
                    q.hideField(this.form.BankId, true);
                    q.hideField(this.form.Scheme, true);
                    q.hideField(this.form.RefNo, true);
                }
                else if (ledger.Type == 283) { //For Gift Voucher
                    Serenity.EditorUtils.setReadOnly(this.form.Amount, true);
                    q.hideField(this.form.ChequeDate, true);
                    q.hideField(this.form.ChequeNo, true);
                    q.hideField(this.form.BankId, true);
                    q.hideField(this.form.Scheme, true);
                    q.hideField(this.form.RefNo, false);
                }
                else if (ledger.Type == 281) {//For Cheque
                    Serenity.EditorUtils.setReadOnly(this.form.Amount, false);
                    q.hideField(this.form.ChequeDate, false);
                    q.hideField(this.form.ChequeNo, false);
                    q.hideField(this.form.BankId, false);
                    
                    q.hideField(this.form.Scheme, true);
                    q.hideField(this.form.RefNo, true);
                }
                else if (ledger.Type == 284) {//For Scheme Voucher
                    Serenity.EditorUtils.setReadOnly(this.form.Amount, true);
                    q.hideField(this.form.ChequeDate, true);
                    q.hideField(this.form.ChequeNo, true);
                    q.hideField(this.form.BankId, true);
                    q.hideField(this.form.Scheme, false);
                    q.hideField(this.form.RefNo, true);
                    this.form.Scheme.cascadeField = "CustomerId";
                    var poscustomerid = (this.parentEditor.parentDialog as ECommSalesDialog).form.POSCustomerId;
                    if (poscustomerid == undefined) {
                        Q.alert('Please Select Customer');
                        this.dialogClose();
                    }
                }
                this.form.RefNo.value = "";
                this.form.Scheme.value = "";

            });
            this.form.RefNo.changeSelect2(e => {
                var details = Retail.GiftVoucherItemDetailsRow.getLookup().items.filter(x => x.UniqueNo == this.form.RefNo.value);
                amount = 0;
                for (var i = 0; i < details.length; i++) {
                    amount += details[i].Amount;
                }
                this.form.Amount.value = amount;
                if (details[0].IsPartial) {

                    Serenity.EditorUtils.setReadOnly(this.form.Amount, false);
                } else { Serenity.EditorUtils.setReadOnly(this.form.Amount, false);}
            });
            this.form.Amount.changeSelect2(e => {
                if (this.form.ModeId.value == "283") {
                    if (this.form.Amount.value > amount) {
                        Q.alert('Gift Voucher Limit Exceded');
                        this.form.Amount.value = amount;
                        return;
                    }
                }
            });
            this.form.Scheme.changeSelect2(e => {
                //var schemedetails = Scheme.SchemeEnrollmentRow.getLookup().itemById[this.form.Scheme.value];
                //var totalamount = schemedetails.SchemeAmount + schemedetails.BonusValue;
                var totalamount = 0;

                Scheme.SchemeMasterService.Retrieve({
                    EntityId: parseInt(this.form.Scheme.value)
                }, response => {
                    totalamount = response.Entity.SchemeAmount + response.Entity.BonusValue;
                }, { async: false });
                this.form.Amount.value = totalamount;
            });
        }
        protected onDialogOpen() {
            super.onDialogOpen();
            if (this.form.ModeId.value != "") {
                var ledger = OMS.PaymentModeRow.getLookup().itemById[this.form.ModeId.value];
                if (ledger.Type == 283) {
                    var details = Retail.GiftVoucherItemDetailsRow.getLookup().items.filter(x => x.UniqueNo == this.form.RefNo.value);
                    amount = 0;
                    for (var i = 0; i < details.length; i++) {
                        amount += details[i].Amount;
                    }
                }
                else if (ledger.Type == 283) {
                    q.hideField(this.form.Scheme, false);
                }

                if (ledger.Type == 280) { //For Gift Voucher
                    Serenity.EditorUtils.setReadOnly(this.form.Amount, false);
                    q.hideField(this.form.ChequeDate, true);
                    q.hideField(this.form.ChequeNo, true);
                    q.hideField(this.form.BankId, true);
                    q.hideField(this.form.Scheme, true);
                    q.hideField(this.form.RefNo, true);
                }
                else if (ledger.Type == 283) { //For Gift Voucher
                    Serenity.EditorUtils.setReadOnly(this.form.Amount, true);
                    q.hideField(this.form.ChequeDate, true);
                    q.hideField(this.form.ChequeNo, true);
                    q.hideField(this.form.BankId, true);
                    q.hideField(this.form.Scheme, true);
                    q.hideField(this.form.RefNo, false);
                }
                else if (ledger.Type == 281) {//For Cheque
                    Serenity.EditorUtils.setReadOnly(this.form.Amount, false);
                    q.hideField(this.form.ChequeDate, false);
                    q.hideField(this.form.ChequeNo, false);
                    q.hideField(this.form.BankId, false);

                    q.hideField(this.form.Scheme, true);
                    q.hideField(this.form.RefNo, true);
                }
                else if (ledger.Type == 284) {//For Scheme Voucher
                    Serenity.EditorUtils.setReadOnly(this.form.Amount, true);
                    q.hideField(this.form.ChequeDate, true);
                    q.hideField(this.form.ChequeNo, true);
                    q.hideField(this.form.BankId, true);
                    q.hideField(this.form.Scheme, false);
                    q.hideField(this.form.RefNo, true);
                    this.form.Scheme.cascadeField = "CustomerId";
                    var poscustomerid = (this.parentEditor.parentDialog as ECommSalesDialog).form.POSCustomerId;
                    if (poscustomerid == undefined) {
                        Q.alert('Please Select Customer');
                        this.dialogClose();
                    }
                }

                if (this.form.ModeId.value == "18") {
                    q.showAndDisableField(this.form.ModeId);
                    q.showAndDisableField(this.form.Amount);
                    q.hideField(this.form.ChequeDate);
                    q.hideField(this.form.ChequeNo);
                    q.hideField(this.form.BankId, true);
                    q.hideField(this.form.Scheme);
                    q.hideField(this.form.RefNo); 
                } else
                    this.form.ModeId.items = this.form.ModeId.items.filter(x => x.id != "18");

            } else {
                q.hideField(this.form.Scheme, true);
                q.hideField(this.form.ChequeNo, true);
                q.hideField(this.form.ChequeDate, true);
                q.hideField(this.form.BankId, true);
                this.form.ModeId.items = this.form.ModeId.items.filter(x => x.id != "18");
            }

        }

        protected afterLoadEntity() {
            super.afterLoadEntity();
            if (this.form.ModeId.value == "") {
                this.form.ModeId.value = "";
                this.form.Amount.value = 0.00;
                this.form.ChequeDate.value = "";
                this.form.ChequeNo.value = 0;
                this.form.RefNo.value = "";
            }
            this.form.Total.value = (this.parentEditor.parentDialog as ECommSalesDialog).form.GrossAmount.value;
            this.form.Balance.value = (this.parentEditor.parentDialog as ECommSalesDialog).form.BalanceAmount.value;


        }

        //loadEntity() {
            
        //    this.form.Total.value = (this.parentEditor.parentTransDialog as ECommSalesDialog).form.GrossAmount.value;
        //    this.form.Balance.value = (this.parentEditor.parentTransDialog as ECommSalesDialog).form.BalanceAmount.value;
        //}
    }
}